import React, { useEffect, useState } from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import Newtemplate from "./Newtemplate";
import Markcondition from "./Markcondition";
import Controlpanel from "./Controlpanel";
import Insertfield from "./Insertfield";
import HomePage from "./HomePage";
import Inserttable from "./Inserttable";
import Checkout from "./Checkout";
import TopAppBar from "./TopAppBar";
import { Box } from "@mui/material";
import Playbook from "./Playbook";
import Chatgptai from "./chatgptai";

/* global console */
const Dashboard = (props: any) => {
  const [myaistate, setmyaistate] = useState(false);
  useEffect(() => {
    console.log("In Dashboard");
    console.log(props);
    setmyaistate(props.isaienable);
  }, [props.isaienable]);
  return (
    <BrowserRouter>
      <TopAppBar {...props} />
      <Box sx={{ padding: 0, margin: 0, height: 38 }} />
      <Box sx={{ padding: 0 }}>
        <Switch>
          <Route exact path="/HomePage" render={(props) => <HomePage Enableaih={myaistate} {...props} />} />
          <Route exact path="/Newtemplate" render={(props) => <Newtemplate Isupdate={false} {...props} />} />
          <Route
            exact
            path="/Markcondition"
            render={(props) => <Markcondition IsClauses={false} IsTableCondition={false} {...props} />}
          />
          <Route
            exact
            path="/Markclause"
            render={(props) => <Markcondition IsClauses={true} IsTableCondition={false} {...props} />}
          />
          <Route
            exact
            path="/Marktable"
            render={(props) => <Markcondition IsClauses={false} IsTableCondition={true} {...props} />}
          />
          <Route exact path="/Controlpanel" render={(props) => <Controlpanel {...props} />} />
          <Route exact path="/CheckIn" render={(props) => <Newtemplate Isupdate={true} {...props} />} />
          <Route
            exact
            path="/Insertfield"
            render={(props) => (
              <Insertfield title="Insert Field" mainfldid="" tablemode={false} insertmode={true} {...props} />
            )}
          />
          <Route exact path="/Inserttable" render={(props) => <Inserttable {...props} />} />
          <Route exact path="/Checkout" render={(props) => <Checkout {...props} />} />
          <Route exact path="/Playbook" render={(props) => <Playbook {...props} />} />
          <Route exact path="/Chatgptai" render={(props) => <Chatgptai {...props} />} />
          <Route exact path="" render={(props: any) => <HomePage Enableaih={myaistate} {...props} />} />
        </Switch>
      </Box>
    </BrowserRouter>
  );
};

export default Dashboard;
